import { InputBase, Menu, MenuItem } from '@mui/material'
import classNames from 'classnames'
import { useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import FieldLabel from '../Form/FieldLabel'
import ArrowDownIcon from '../Icons/ArrowDownIcon'

export default function SelectField(props) {
  const {
    options = [],
    optionsKeys: { valueKey = '', labelKey = '' } = {},
    name = '',
    value = '',
    standalone = false,
    setter = null,
    formikSetter = null,
    handler = null,
    placeholder = '',
    className = 'input_field select_field',
    onBlur,
    // ...restProps
  } = props
  // console.log({ standalone, value })
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const inputRef = useRef(null)
  const dispatch = useDispatch()

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSelect = (option) => {
    if (standalone) {
      if (setter) {
        dispatch(setter(option))
      }
    } else {
      // console.log({ name, option })
      formikSetter(name, option)
      if (handler) {
        handler({ name, option })
      }
    }
    handleClose()
  }

  const getSelectLabel = (value) => {
    const obj = options.find((o) => o[valueKey] === value)
    return obj?.[labelKey] || ''
  }

  return (
    <MaybeWrapped {...props}>
      <InputBase
        id={name}
        value={getSelectLabel(value)}
        onClick={handleOpen}
        name={name}
        onBlur={onBlur}
        readOnly
        placeholder={placeholder}
        ref={inputRef}
        className={classNames(className, { select_open: open })}
        endAdornment={<ArrowDownIcon />}
      />
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        className="select_menu"
        slotProps={{
          paper: {
            style: {
              width: inputRef.current ? inputRef.current.offsetWidth : undefined,
            },
          },
        }}
      >
        {options.map((o, ind) => (
          <MenuItem
            key={o?.id || o?.ex_id || o?.[valueKey] + `_ind_${ind}`}
            onClick={() => handleSelect(o[valueKey])}
          >
            {o?.[labelKey]}
          </MenuItem>
        ))}
      </Menu>
    </MaybeWrapped>
  )
}

const MaybeWrapped = ({ children, standalone, label, name, required }) => {
  if (standalone) {
    const labelProps = {
      label,
      name,
      required,
    }
    return (
      <div className="input_field_wrapper select_field_wrapper">
        {label && <FieldLabel {...labelProps} />}
        {children}
      </div>
    )
  } else return <>{children}</>
}
